import type { SaleType } from '../../api/types';

export const SALE_TYPE_OPTIONS: { value: SaleType; label: string }[] = [
  { value: 'license_revenue', label: 'License Revenue' },
  { value: 'digital_revenue', label: 'Digital Revenue' },
  { value: 'format_revenue', label: 'Format Revenue' },
  { value: 'clip_license_revenue', label: 'Clip License Revenue' },
  { value: 'digital_revenue_youtube', label: 'Digital Revenue - YouTube' },
  { value: 'digital_revenue_avod', label: 'Digital Revenue - AVOD' },
  { value: 'merchandising_revenue', label: 'Merchandising Revenue' },
];

export function saleTypeLabel(value: SaleType | null): string {
  return SALE_TYPE_OPTIONS.find((option) => option.value === value)?.label ?? '—';
}
